<template>
    <div>
        <page-header :buttons="pageActions.buttons" :additional="pageActions.additional" @method="methodHandler">
            <template slot="title">Import Wizard</template>
        </page-header>
        <div class="pt-10 flex w-full justify-center align-center bg-grey-lightest h-screen" v-show="step === 1">
            <div class="w-1/2 border bg-white h-48 relative">
                <div class="relative pin-l pin-r pin-t block p-8" style="background: #E5E5E5;">
                    <p class="py-1 text-sm text-center">Upload the XLS/CSV file that contains the records to be imported (ensure the first row contains column headings). The next step will be to match the fields in the file with the available fields.</p>
                </div>
                <form novalidate="" autocomplete="Off" role="form" name="import_form" method="post" @submit.prevent="upload" enctype="multipart/form-data">
                    <div class="flex flex-row items-center align-center justify-center w-full pt-6 px-8 text-center">
                        <input type="file" id="file" name="file" ref="importFile" @change="selectedFile" required="required" accept=".csv,.xlsx" class="form-control" autocomplete="false" style="line-height: 16px;">
                        <span class="input-group-btn"><button type="submit" id="start" name="start" class="bg-green-500 text-white px-4 py-1" :class="{'cursor-not-allowed opacity-50': disableButton}" :disabled="disableButton"><i class="fa fa-upload "></i> Upload</button></span>
                    </div>
                </form>
            </div>
        </div>
        <div class="pt-10 flex w-full justify-center align-center bg-grey-lightest h-screen" v-show="step === 2">
            <div class="w-full px-8">
                <p class="w-full text-center pb-12 text-sm">Match the columns from the imported file to the available fields.</p>
                <div class="flex w-full flex-wrap">
                    <div class="w-1/4 mb-10 pr-8" v-for="(field, index) in fields" v-bind:key="index">
                        <div class="form-group">
                            <label class="label text-sm">{{ field.name }}</label>
                            <select class="w-full border py-2 text-sm outline-none" v-model="field.index">
                                <option value="" class="text-sm"></option>
                                <option :value="index" v-for="(heading, index) in headings" v-bind:key="index" class="text-sm">{{ heading }}</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <div class="pt-10 flex w-full content-start justify-center align-center bg-grey-lightest h-screen" v-show="step === 3">
            <div class="w-3/4">
                <div class="text-center">
                    <p class="py-1 font-bold mb-4" :class="{ 'text-red': errors.length > 0 }">{{ resultMessage }}</p>
                    <p class="py-1" v-for="(error, index) in errors" :key="index">{{ error }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";

    export default {
        props: ['type'],
        data: function(){
            return {
                pageActions: {
                    buttons: [
                        {
                            label: 'Cancel',
                            icon: 'times',
                            iconClass: 'text-red-500',
                            type: 'method',
                            method: 'cancel'
                        }
                    ]
                },
                step: 1,
                fields: [],
                headings: [],
                disableButton: true,
                filename: '',
                error: false,
                resultMessage: '',
                importedRows: null,
                errors: []
            }
        },
        mounted() {
            this.getFields();
        },
        methods: {
            getFields: function(){
                this.$Progress.start();

                axios.get(process.env.VUE_APP_API_URL + '/import/fields', {
                    params: {
                        type: this.type
                    }
                }).then(response => {
                    this.fields = response.data.data;
                    this.$Progress.finish();
                })
                .catch(() => {
                    this.$Progress.finish();
                });
            },
            upload: function(){
                if (this.fields.length > 0){
                    this.$store.commit('TOGGLE_BACKDROP', { open: true });

                    const formData = new FormData();
                    const file = document.querySelector('#file');
                    formData.append("file", file.files[0]);

                    axios({
                        method: 'POST',
                        url: process.env.VUE_APP_API_URL + '/import/upload',
                        headers: {
                            'content-type': 'multipart/form-data'
                        },
                        data: formData
                    }).then(response => {
                        this.headings = response.data.columns;
                        this.filename = response.data.filename;
                        this.step = 2;
                        this.pageActions.buttons.unshift({
                            label: 'Import',
                            icon: 'upload',
                            type: 'method',
                            method: 'startImport',
                            iconClass: 'text-green-500',
                        })
                        this.$store.commit('TOGGLE_BACKDROP', { open: false });
                    })
                    .catch(() => {
                        this.$store.commit('TOGGLE_BACKDROP', { open: false });
                    });
                } else {
                    this.$notify({
                        group: 'main',
                        position: 'top right',
                        type: 'error',
                        title: 'Error',
                        text: 'Unable to start import due to missing import mapping fields.',
                        duration: 8000
                    });
                }
            },
            startImport: function(){
                this.$store.commit('TOGGLE_BACKDROP', { open: true });

                axios({
                    method: 'POST',
                    url: process.env.VUE_APP_API_URL + '/import',
                    data: {
                        filename: this.filename,
                        fields: this.fields,
                        type: this.type
                    }
                }).then(response => {
                    if (!response.data.success){
                        this.errors = response.data.errors;
                    }
                    this.resultMessage = response.data.message;
                    this.headings = [];
                    this.filename = '';
                    this.disableButton = true;
                    this.step = 3;
                    this.$store.commit('TOGGLE_BACKDROP', { open: false });
                })
                .catch(() => {
                    this.$store.commit('TOGGLE_BACKDROP', { open: false });
                });
            },
            selectedFile: function(){
                this.disableButton = this.$refs.importFile.files.length <= 0;
            },
            cancel: function(){
                window.history.go(-1);
            },
            methodHandler: function(method){
                this[method]();
            },
            actionHandler: function(data){
                this[data.method](data);
            }
        },
        computed: {

        }
    }
</script>
